export default {
  methods: {
    getExternalLabelValue(data) {
      if (data.video_source === 's3') {
        return 'S3 Bucket'
      }
      if (data.video_source === 'youtube') {
        return 'Youtube'
      }
      if (data.video_source === 'vimeo') {
        return 'Vimeo'
      }
      let finalStr = data.video_url
      if (data.video_url.includes('://') || data.video_url.includes('www')) {
        let splitString = data.video_url.includes('://') ? '://' : 'wwww.'
        finalStr = finalStr.split(splitString)[1]
        finalStr = finalStr.split('/')[0]
      }
      return finalStr
    },
    handleKamount(amount) {
      amount = Number(amount)
      if (amount > 999) {
        let slicedAmount = String(amount).slice(0, -3)
        const dotValue = String(amount)[slicedAmount.length]
        if (dotValue && dotValue != 0) {
          slicedAmount = `${slicedAmount}.${dotValue}`
        }
        amount = `${slicedAmount}K`
      }
      return amount
    },
  },
}
